import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { Invoice } from "@common/types/invoice";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { useEntitiesById } from "@hooks/useEntities";
import { AvatarTooltip } from "@components/avatar/AvatarTooltip";
import { EntityAvatar } from "@components/avatar/EntityAvatar";
import styles from "./EntityCell.module.scss";

export const EntityCell = memo(
    ({ row }: CellContext<ViewTableFeatures, Invoice, unknown>) => {
        const entitiesById = useEntitiesById();
        const entity = entitiesById.get(row.original.entityId);

        return (
            <ViewTableCell className={styles.entityCell}>
                {entity && (
                    <AvatarTooltip content={entity.name}>
                        <EntityAvatar
                            size="xs"
                            entity={entity}
                            copyId={entity.id}
                        />
                    </AvatarTooltip>
                )}
            </ViewTableCell>
        );
    },
);
